var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Predloha"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M143.277 73.866h32.248v95.541h-32.248zM24.547 99.258h32.248v70.15H24.547zM83.912 32.19h32.248v137.217H83.912z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M10.866 171.362h177.362"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M143.277 75.332h32.248v95.541h-32.248zM24.547 100.724h32.248v70.15H24.547zM83.912 33.656h32.248v137.217H83.912z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.6886aefb9f2dc819818f19eb257d7342.svg";
export { ForwardRef as ReactComponent };